import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import { initYandexMetrika } from './utils/metrika.js';
import './styles/tokens.css';
import './styles/app.css';
import './styles/account.css';
import './styles/landing.css';

// Яндекс.Метрика — подключается только если задан VITE_YANDEX_METRIKA_ID
// (т.е. только на PROD; на DEV/IP — no-op).
initYandexMetrika();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter><App /></BrowserRouter>
  </React.StrictMode>
);
